var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": false,
      "return-value": _vm.month,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function updateReturnValue($event) {
        _vm.month = $event;
      },
      "update:return-value": function updateReturnValue($event) {
        _vm.month = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return [_c('v-text-field', _vm._g(_vm._b({
          staticClass: "mx-auto",
          attrs: {
            "width": "100",
            "prepend-inner-icon": "mdi-calendar",
            "append-icon": "mdi-chevron-down",
            "readonly": "",
            "hide-details": ""
          },
          model: {
            value: _vm.month,
            callback: function callback($$v) {
              _vm.month = $$v;
            },
            expression: "month"
          }
        }, 'v-text-field', _vm.$attrs, false), on))];
      }
    }])
  }, [_c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "type": "month"
    },
    on: {
      "input": function input($event) {
        _vm.$refs.menu.save(_vm.month);

        _vm.$emit('input', _vm.month);
      }
    },
    model: {
      value: _vm.month,
      callback: function callback($$v) {
        _vm.month = $$v;
      },
      expression: "month"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }